import i18next from "i18next";

const applyFont = (lng: string) => {
  const font =
    lng === "ja"
      ? "SourceHanSans JP Normal"
      : "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji";
  document.documentElement.style.setProperty("--app-font-family", font);
  document.documentElement.setAttribute("lang", lng);
};

export const initFontListener = () => {
  applyFont(i18next.language);
  i18next.on("languageChanged", (lng) => {
    applyFont(lng);
  });
};
